import { IconButton } from "@chakra-ui/react";

interface SliderIconButtonProps {
    ariaLabel: string,
    isLeft: boolean,
    side: any,
    top: any,
    clickHandler: any,
    children: any
};

const SliderIconButton: React.FC<SliderIconButtonProps> = ({ ariaLabel, isLeft, side, top, clickHandler, children }) => {
    return (
        <IconButton
            display={{ base: 'none', md: 'flex' }}
            aria-label={ariaLabel}
            colorScheme="whiteAlpha"
            borderRadius="full"
            position="absolute"
            left={isLeft ? side : []}
            right={!isLeft? side: []}
            top={top}
            transform={'translate(0%, -50%)'}
            zIndex={2}
            variant="solid"
            background={"whiteAlpha.900"}
            color={"blackAlpha.900"}
            onClick={() => clickHandler()}>
            {children}
        </IconButton>
    );
};

export default SliderIconButton;